import { LegalClientFinancialMonitoringEntity } from 'api/types/entity';
import { yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';

import {
  CompanyFinanceFinancialMonitoringFormType,
  getAmlPolicyReviewFrequencySelectedOption,
  getMonetaryServiceTransactionCountForLastSixMonthsSelectedOption,
} from '../../forms/companyFinanceFinancialMonitoringForm';

export const parseFinanceFinancialMonitoringValue = (
  t: TFunc,
  data?: LegalClientFinancialMonitoringEntity
): CompanyFinanceFinancialMonitoringFormType['financeFinancialMonitoring'] => {
  if (!data) {
    return {} as CompanyFinanceFinancialMonitoringFormType['financeFinancialMonitoring'];
  }

  return {
    isSubjectToRegulation: yesOrNotOption(t, data.isSubjectToRegulation),
    authorityName: data.financeInfo?.authorityName,
    authorityWebsite: data.financeInfo?.authorityWebsite ?? '',
    hasAmlCftComplianceControl: yesOrNotOption(
      t,
      data.financeInfo?.hasAmlCftComplianceControl
    ),
    hasTransactionMonitoringAndSuspiciousActivityDetection: yesOrNotOption(
      t,
      data.financeInfo?.hasTransactionMonitoringAndSuspiciousActivityDetection
    ),
    amlPolicyReviewFrequency:
      getAmlPolicyReviewFrequencySelectedOption(
        t,
        data.financeInfo?.amlPolicyReviewFrequency
      ) || null,
    otherAmlPolicyReviewFrequency:
      data.financeInfo?.otherAmlPolicyReviewFrequency ?? '',
    amlCftPoliciesApplyToForeignEntities: yesOrNotOption(
      t,
      data.financeInfo?.amlCftPoliciesApplyToForeignEntities ?? undefined
    ),
    hasAmlCftDocumentEffectivenessAssessmentProcedures: yesOrNotOption(
      t,
      data.financeInfo?.hasAmlCftDocumentEffectivenessAssessmentProcedures
    ),
    dateOfLastCheck: data.financeInfo?.dateOfLastCheck ?? undefined,
    hasAmlCftInternalControlOfficer: yesOrNotOption(
      t,
      data.financeInfo?.hasAmlCftInternalControlOfficer
    ),
    officerFirstName: data.financeInfo?.officer?.firstName,
    officerLastName: data.financeInfo?.officer?.lastName,
    officerMiddleName: data.financeInfo?.officer?.middleName ?? '',
    officerPosition: data.financeInfo?.officer?.position,
    officerPhoneNumber: data.financeInfo?.officer?.phoneNumber ?? '',
    officerEmail: data.financeInfo?.officer?.email,
    canProvideAmlPolicyDocuments: yesOrNotOption(
      t,
      data.financeInfo?.canProvideAmlPolicyDocuments
    ),
    documentProvisionRefusalReason:
      data.financeInfo?.documentProvisionRefusalReason ?? '',
    isInternalControlInfoConfidential: yesOrNotOption(
      t,
      data.financeInfo?.isInternalControlInfoConfidential
    ),
    hadAmlCftInvestigationsOrPenalties: yesOrNotOption(
      t,
      data.financeInfo?.hadAmlCftInvestigationsOrPenalties
    ),
    investigationOrPenaltyReasons:
      data.financeInfo?.investigationOrPenaltyReasons ?? '',
    hasMandatoryControlTransactions: yesOrNotOption(
      t,
      data.financeInfo?.hasMandatoryControlTransactions
    ),
    mandatoryControlTransactionIdentificationProcedure:
      data.financeInfo?.mandatoryControlTransactionIdentificationProcedure ??
      '',
    monetaryServiceTransactionCountForLastSixMonths:
      getMonetaryServiceTransactionCountForLastSixMonthsSelectedOption(
        t,
        data.financeInfo?.monetaryServiceTransactionCountForLastSixMonths
      ) || null,
    isAffiliatedWithNonProfitOrganizations: yesOrNotOption(
      t,
      data.financeInfo?.isAffiliatedWithNonProfitOrganizations
    ),
    receivesFundingFromStateBudget: yesOrNotOption(
      t,
      data.financeInfo?.receivesFundingFromStateBudget
    ),
    receivesFundingFromForeignNonProfitNGOs: yesOrNotOption(
      t,
      data.financeInfo?.receivesFundingFromForeignNonProfitNGOs
    ),
    isCompliantWithFATFRecommendations: yesOrNotOption(
      t,
      data.financeInfo?.isCompliantWithFATFRecommendations
    ),
    hasBeenRefusedToOpenAccountByBanks: yesOrNotOption(
      t,
      data.financeInfo?.hasBeenRefusedToOpenAccountByBanks
    ),
  };
};
